module.exports = __webpack_public_path__ + "static/media/edit.05c21652.svg";